import { AppBar } from '@mui/material';
import { AppBarProps } from '@mui/material/AppBar';
import { withStyles, WithStyles } from "@mui/styles";
import { FilterBarStyleClasses } from 'assets/jss/common-styles';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import * as React from 'react';

interface IProps {
    margin?: 'dense' | 'normal' | 'none';
}

type Props = IProps & Omit<AppBarProps, 'classes'> & WithStyles<typeof FilterBarStyleClasses>;

const MuiFilterAppBar: React.FC<Props> = (props) => {
    const { classes, margin, ...rest } = props;
    return (
        <MuiContainer margin={margin}>
            <AppBar {...rest} classes={{ root: classes.appTabFilterRoot }} />
        </MuiContainer>
    );
};

MuiFilterAppBar.defaultProps = {
    margin: "normal"
}

export default withStyles(FilterBarStyleClasses)(MuiFilterAppBar)